import {
  FeedbackBlock,
  FeedbackBlockButtons,
  FeedbackBlockGraphic,
  FeedbackBlockTitle,
} from '@/components/ui/feedback-block'

export const NotFoundPage = () => (
  <FeedbackBlock className="h-screen bg-gray-25">
    <FeedbackBlockGraphic />
    <FeedbackBlockTitle title="Página não encontrada." />
    <FeedbackBlockButtons />
  </FeedbackBlock>
)
